
import { Component, Vue, Prop } from 'vue-property-decorator';

interface TimelineStatus {
  key: string;
  label: string;
  shortLabel: string;
  icon: string;
  color: string;
  description: string;
}

@Component({
  name: 'POStatusTimeline'
})
export default class POStatusTimeline extends Vue {
  @Prop({ required: true }) readonly currentStatus!: string;

  private readonly statusOrder = ['draft', 'confirmed', 'partial_received', 'received', 'completed'];

  get timelineStatuses(): TimelineStatus[] {
    return [
      {
        key: 'draft',
        label: 'Draft',
        shortLabel: 'Draft',
        icon: 'mdi-file-document-edit-outline',
        color: 'grey',
        description: 'Initial state when PO is created.'
      },
      {
        key: 'confirmed',
        label: 'Confirmed',
        shortLabel: 'Confirmed',
        icon: 'mdi-check-circle-outline',
        color: 'purple',
        description: 'PO is confirmed and ready for receiving.'
      },
      {
        key: 'partial_received',
        label: 'Partially Received',
        shortLabel: 'Partial',
        icon: 'mdi-package-variant',
        color: 'orange',
        description: 'Some items have been received.'
      },
      {
        key: 'received',
        label: 'Fully Received',
        shortLabel: 'Received',
        icon: 'mdi-package-check',
        color: 'green',
        description: 'All ordered quantities received.'
      },
      {
        key: 'completed',
        label: 'Completed',
        shortLabel: 'Complete',
        icon: 'mdi-check-circle',
        color: 'teal darken-2',
        description: 'PO is finalized. Terminal state.'
      }
    ];
  }

  isStatusCompleted(statusKey: string): boolean {
    if (this.currentStatus === 'canceled') return false;
    const currentIndex = this.statusOrder.indexOf(this.currentStatus);
    const statusIndex = this.statusOrder.indexOf(statusKey);
    return statusIndex < currentIndex;
  }

  isStatusFuture(statusKey: string): boolean {
    if (this.currentStatus === 'canceled') return true;
    const currentIndex = this.statusOrder.indexOf(this.currentStatus);
    const statusIndex = this.statusOrder.indexOf(statusKey);
    return statusIndex > currentIndex;
  }

  isConnectorCompleted(index: number): boolean {
    if (this.currentStatus === 'canceled') return false;
    const currentIndex = this.statusOrder.indexOf(this.currentStatus);
    return index < currentIndex;
  }

  getStepStyle(statusKey: string): Record<string, string> {
    const status = this.timelineStatuses.find(s => s.key === statusKey);
    if (!status) return {};

    if (this.isStatusCompleted(statusKey)) {
      return { backgroundColor: '#4caf50' };
    }

    if (this.currentStatus === statusKey) {
      const colorMap: Record<string, string> = {
        'grey': '#9e9e9e',
        'purple': '#9c27b0',
        'orange': '#ff9800',
        'green': '#4caf50',
        'teal darken-2': '#00796b'
      };
      return { backgroundColor: colorMap[status.color] || '#9e9e9e' };
    }

    return {
      backgroundColor: '#e0e0e0',
      border: '2px solid #bdbdbd'
    };
  }
}
